import { render, staticRenderFns } from "./ConvenioDadosDespesa.vue?vue&type=template&id=821a5f08"
import script from "./ConvenioDadosDespesa.vue?vue&type=script&lang=js"
export * from "./ConvenioDadosDespesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports